<div class="page-library-container">
  <div class="page-section" *ngFor="let section of sections">
    <!-- Section Header (clickable) -->
    <div class="section-header" *ngIf="showSection(section.name)" (click)="toggleSection(section)">
      <mat-icon class="expand-icon">
        {{ section.isExpanded ? 'expand_more' : 'chevron_right' }}
      </mat-icon>
      <span class="section-name">{{ section.name }}</span>
      <span class="section-count">({{ section.pages.length }})</span>
    </div>
    
    <!-- Section Content (collapsible) -->
    <div class="section-content" *ngIf="showSection(section.name)" [class.collapsed]="!section.isExpanded">
      <div 
        class="page-thumbnail" 
        *ngFor="let page of section.pages"
        [style.aspect-ratio]="getThumbnailAspectRatio(page)"
        [style.max-width]="getThumbnailMaxWidth(page)"
        draggable="true"
        (dragstart)="onDragStart($event, page)">
        <img [src]="page.thumbnail" [alt]="page.name" width="100%" />
      </div>
    </div>
  </div>
</div>